export const MATCHES_TAB_MENU_SLUGS = {
    LIVE: 'live',
    TODAY: 'today',
    TOMORROW: 'tomorrow',
    UPCOMING: 'upcoming',
};
export const MATCHES_TAB_DEFAULT_ITEM = MATCHES_TAB_MENU_SLUGS.TODAY;
export const GTM_CAROUSEL_MATCHES = 'matches';
